// ============================================================
// Billing — usage ledger (DB_PLATFORM `usage_reports`)
//
// One row per tenant, metric and UTC day: what YOM counted, what the provider confirmed,
// and the send in flight (metering.ts explains the pending → commit protocol). Rows are
// bounded by tenants × days, never by traffic. Read by the reconciliation report.
// ============================================================
export const USAGE_REPORTS_DDL = [
    `CREATE TABLE IF NOT EXISTS usage_reports (
        tenant_id TEXT NOT NULL,
        metric TEXT NOT NULL,
        day TEXT NOT NULL,
        period TEXT NOT NULL,
        provider TEXT NOT NULL,
        counted INTEGER NOT NULL DEFAULT 0,
        reported INTEGER NOT NULL DEFAULT 0,
        pending_total INTEGER,
        pending_id TEXT,
        pending_ts INTEGER,
        attempts INTEGER NOT NULL DEFAULT 0,
        last_error TEXT,
        reported_at TEXT,
        updated_at TEXT NOT NULL DEFAULT (datetime('now')),
        PRIMARY KEY (tenant_id, metric, day)
    )`,
    'CREATE INDEX IF NOT EXISTS idx_usage_reports_period ON usage_reports(period, tenant_id)',
];
/** Ledger totals per tenant and metric for one billing period (YYYY-MM). */
export async function ledgerTotals(db, period, tenantId) {
    const { results } = await db
        .prepare(`SELECT tenant_id, metric, provider,
                    SUM(counted) AS counted, SUM(reported) AS reported,
                    SUM(CASE WHEN pending_total IS NULL THEN 0 ELSE pending_total - reported END) AS pending,
                    COUNT(*) AS days, MAX(last_error) AS last_error, MAX(reported_at) AS last_reported_at
             FROM usage_reports
             WHERE period = ?${tenantId ? ' AND tenant_id = ?' : ''}
             GROUP BY tenant_id, metric, provider
             ORDER BY tenant_id, metric`)
        .bind(...(tenantId ? [period, tenantId] : [period]))
        .all();
    return (results ?? []).map(r => ({
        tenantId: r.tenant_id,
        metric: r.metric,
        provider: r.provider,
        counted: Number(r.counted) || 0,
        reported: Number(r.reported) || 0,
        pending: Number(r.pending) || 0,
        days: Number(r.days) || 0,
        lastError: r.last_error,
        lastReportedAt: r.last_reported_at,
    }));
}
//# sourceMappingURL=ledger.js.map